import logo from "../assets/images/jobhunt_logo.svg"

function Logo() {
  return (
    <img src={logo} alt="JobHunt" className="logo" />
  )
}

export default Logo